module.exports = __webpack_public_path__ + "img/etoa@2x.a60dd57.png";